module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: {
      'faa-flash animated': _vm.showChangedRecently > 0
    },
    attrs: {
      "data-toggle": "popover",
      "data-placement": "top",
      "data-trigger": "hover"
    }
  }, [(_vm.scheduledRound) ? _c('span', {
    style: ({
      opacity: (_vm.status == 0 ? '0.3' : '1')
    })
  }, [_c('span', {
    staticClass: "fa-stack fa-2x ",
    class: {
      'text-muted': _vm.status == 0, 'text-success': _vm.status == 15, 'text-warning': _vm.status == 25, 'text-warning': _vm.status == 35, 'text-danger': _vm.status == 40
    },
    staticStyle: {
      "margin": "-10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-stack-1x",
    class: {
      'fa-circle-o text-muted': _vm.status == 0, 'fa-check text-success': _vm.status == 15, 'fa-repeat text-warning': _vm.status == 25, 'fa-clock-o text-warning': _vm.status == 35, 'fa-exclamation-triangle text-danger': _vm.status == 40
    }
  }), _vm._v(" "), _c('strong', {
    staticStyle: {
      "margin-left": "38px",
      "margin-top": "6px",
      "width": "auto"
    }
  }, [_c('small', {
    staticStyle: {
      "font-size": "12px",
      "opacity": "0.5"
    }
  }, [_vm._v(_vm._s(_vm.primaryCount))])])]), _vm._v(" "), _vm._l((_vm.secondaryItems), function(item) {
    return _c('span', {
      staticClass: "fa-stack fa-1x ",
      class: {
        'text-muted': item.status == 0, 'text-success': item.status == 15, 'text-warning': item.status == 25, 'text-warning': item.status == 35, 'text-danger': item.status == 40
      },
      staticStyle: {
        "margin-left": "3px"
      }
    }, [_c('i', {
      staticClass: "fa fa-stack-1x",
      class: {
        'fa-circle-o text-muted': item.status == 0, 'fa-check text-success': item.status == 15, 'fa-repeat text-warning': item.status == 25, 'fa-clock-o text-warning': item.status == 35, 'fa-exclamation-triangle text-danger': item.status == 40
      }
    }), _vm._v(" "), _c('small', {
      staticStyle: {
        "font-size": "10px",
        "opacity": "0.8"
      }
    }, [_c('strong', {
      staticClass: "fa-stack-1x",
      staticStyle: {
        "margin-left": "15px",
        "margin-top": "6px",
        "margin-right": "0px",
        "margin-bottom": "0px",
        "width": "auto"
      }
    }, [_vm._v(_vm._s(item.count))])])])
  })], 2) : _c('span', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.primaryCount > 0),
      expression: "primaryCount > 0"
    }],
    staticClass: "fa-stack fa-1x",
    class: {
      'text-muted': _vm.status == 0, 'text-success': _vm.status == 15, 'text-warning': _vm.status == 25, 'text-warning': _vm.status == 35, 'text-danger': _vm.status == 40
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o fa-stack-2x"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa-stack-1x"
  }, [_c('small', [_c('strong', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(this.group.medRoundGroupName.charAt(0)))])])])]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.primaryCount || _vm.primaryCount <= 0),
      expression: "!primaryCount || primaryCount <= 0"
    }],
    staticClass: "fa fa-2x fa-circle-o text-muted",
    style: ({
      opacity: (this.group.medRoundGroupStatus == 0 ? '0.3' : '1')
    })
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61c5ed85", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61c5ed85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/dispensationStatusIcon/dispensationStatusIcons.scp.html
// module id = 551
// module chunks = 0